import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import _ from "lodash";
import React, { useContext, useEffect, useState } from "react";
import { useNavigate } from 'react-router-dom';
import { Button, ButtonGroup, Col, Row, Table } from "reactstrap";
import { ItemDropdownMenu, OrderDropdownMenu, SortHeader } from ".";
import { constants, dateHelpers, helpers, UserContext } from "../utils";

export default function NewOrdersCurrentWeekGrid(props) {
   const userCtx = useContext(UserContext);
   const currentUser = userCtx.currentUser;
   const navigate = useNavigate();
   const [data, setData] = useState();
   const [working, setWorking] = useState(false);
   let alreadyDisplayedList = [];

   useEffect(() => {
      if (data !== props.data) {
         setData(props.data)
      }
      // eslint-disable-next-line react-hooks/exhaustive-deps
   }, [props.data])

   function getExcel() {
      setWorking(true);
      props.exportXlsxCallback();
      setWorking(false);
   }

   function sendToCustDash(custId, custName) {
      userCtx.setCustomerFilter(custId);

      navigate(constants.ENDPOINTS.customerDashboard, {
         state: { value: custId, label: `${custId} | ${custName}` }
      })
   }

   return (
      <React.Fragment>
         <Row className="align-items-center">
            <Col className="transparent-background">
               <ButtonGroup className="float-end">
                  {data && data.length && props.exportXlsxCallback && (
                     <Button
                        title="Download as .xlsx"
                        className="shredButtonExcel float-end ms-2"
                        onClick={getExcel}
                        disabled={working}
                     >
                        <FontAwesomeIcon icon="file-excel" size="lg" />
                     </Button>
                  )}
               </ButtonGroup>
            </Col>
         </Row>
         <Table size="sm" className="data-table">
            <thead className="table-header">
               <tr>
                  <th style={{ width: "7%" }}>
                     <SortHeader
                        displayName="Order"
                        field="OrderId"
                        sortDirection={props.sortDirection}
                        sorted={props.sortField === "OrderId"}
                        callback={props.sortCallback}
                     />
                  </th>
                  <th style={{ width: "8%" }}>
                     <SortHeader
                        displayName={<span>Order<br />Date</span>}
                        field="DocumentDate"
                        sortDirection={props.sortDirection}
                        sorted={props.sortField === "DocumentDate"}
                        callback={props.sortCallback}
                     />
                  </th>
                  <th style={{ width: "12%" }}>
                     <SortHeader
                        displayName="Customer"
                        field="CustomerIdNameShipCity"
                        sortDirection={props.sortDirection}
                        sorted={props.sortField === "CustomerIdNameShipCity"}
                        callback={props.sortCallback}
                     />
                  </th>
                  <th style={{ width: "10%" }}>
                     <span>Customer<br />Part</span>
                  </th>
                  <th style={{ width: "12%" }}>Item</th>
                  {props.isCompletedOrdersData
                     ? null
                     : <th style={{ width: "10%" }}>
                        <span>Req Ship<br />Date</span>
                     </th>
                  }
                  <th style={{ width: "10%" }}>
                     <span>Qty<br />Ordered</span>
                  </th>
                  {!currentUser?.isEditRole && !currentUser?.isAdmin
                     ? null
                     : <th style={{ width: "7%" }}>Cost</th>
                  }
                  {!currentUser?.isEditRole && !currentUser?.isAdmin
                     ? null
                     : <th style={{ width: "7%" }}>Ext Cost</th>
                  }
                  <th style={{ width: "7%" }}>Price</th>
                  <th style={{ width: "7%" }}>Ext Price</th>
                  {!currentUser?.isEditRole && !currentUser?.isAdmin
                     ? null
                     : <th style={{ width: "10%" }}>Margin</th>
                  }
               </tr>
            </thead>
            <tbody>
               {_.map(data, (datum, index) => {
                  const alreadyDisplayed = _.includes(alreadyDisplayedList, datum.orderId);
                  alreadyDisplayedList.push(datum.orderId);
                  return (
                     <tr
                        key={index}
                        className={`tr-${index % 2 === 0 ? "primary" : "secondary"}`}
                     >
                        {alreadyDisplayed
                           ? <>
                              <td></td>
                              <td></td>
                              <td></td>
                           </>
                           : <>
                              <OrderDropdownMenu
                                 invoiceNumber={helpers.startsWithNumber(datum.orderId) || datum.orderId.startsWith("IWO") ? datum.orderId : null}
                                 orderId={helpers.startsWithNumber(datum.orderId) ? datum.OriginalOrderId : datum.orderId}
                                 attachmentCount={datum.soAttachmentCount}
                                 orderType={datum.orderType}
                                 itemNumber={datum.itemNumber}
                                 customerId={datum.customerId}
                              />
                              <td className="data-cell" children={dateHelpers.toLongDateString(datum.documentDate)} />
                              <td className="data-cell">
                                 <span
                                    className="shredLink fw-bold"
                                    onClick={() => sendToCustDash(datum.customerId, datum.customerName)}
                                 >
                                    {datum.customerIdNameShipCity}
                                 </span>
                              </td>
                           </>
                        }
                        <td className="data-cell" children={datum.customerItemNumber} />
                        <ItemDropdownMenu
                           itemNumber={datum.itemNumber}
                           itemDescription={datum.itemWithDesc}
                           attachmentCount={datum.itemAttachmentCount}
                           customerId={datum.customerId}
                        />
                        {props.isCompletedOrdersData
                           ? null
                           : <td className="data-cell" children={dateHelpers.toLongDateString(datum.requiredShipDate)} />
                        }
                        <td className="data-cell" children={props.isCompletedOrdersData ? datum.qtytoinv : datum.qtyRemaining} />
                        {!currentUser?.isEditRole && !currentUser?.isAdmin
                           ? null
                           : <React.Fragment>
                              <td className="data-cell" children={helpers.formatCurrency(datum.unitCost)} />
                              <td className="data-cell" children={
                                 props.isCompletedOrdersData
                                    ? helpers.formatCurrency(datum.extendedCost)
                                    : helpers.formatCurrency(datum.unitCost * datum.qtyRemaining)}
                              />
                           </React.Fragment>
                        }
                        <td className="data-cell" children={helpers.formatCurrency(datum.unitPrice)} />
                        <td className="data-cell" children={
                           props.isCompletedOrdersData
                              ? helpers.formatCurrency(datum.extendedPrice)
                              : helpers.formatCurrency(datum.unitPrice * datum.qtyRemaining)} />
                        {!currentUser?.isEditRole && !currentUser?.isAdmin
                           ? null
                           : <td className="data-cell" children={datum.marginDisplay} style={datum.margin < 0 ? { color: "red" } : null} />
                        }
                     </tr>
                  );
               })}
            </tbody>
            <tfoot className="table-footer">
               <tr>
                  {/* <td colSpan={!currentUser?.isEditRole && !currentUser?.isAdmin ? "5" : "6"}></td> */}
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  {props.isCompletedOrdersData
                     ? null
                     : <td></td>
                  }
                  <td
                     className={`fw-bold`}
                     children="TOTALS:"
                  />
                  <td></td>
                  {!currentUser?.isEditRole && !currentUser?.isAdmin
                     ? null
                     : <td className={`fw-bold`}>
                        {helpers.formatCurrency(props.totalCost)}
                     </td>
                  }
                  {!currentUser?.isEditRole && !currentUser?.isAdmin
                     ? null
                     : <td></td>
                  }
                  <td className={`fw-bold`}>
                     {helpers.formatCurrency(props.totalPrice)}
                  </td>
                  {!currentUser?.isEditRole && !currentUser?.isAdmin
                     ? null
                     : <td className={`fw-bold`}>
                        {props.marginTotalDisplay}
                     </td>
                  }
               </tr>
            </tfoot>
         </Table>
      </React.Fragment>
   );
}
